import * as FormControl from '../utils/form-controls';
import * as CONST from '../utils/constants';

// global window
const filterObj = CONST.globalProject.AdvocacyAlertFilters;

// initial state
// object name must match specification name
const filters = {
	AdvocacyAlertRelatedState: new FormControl.FilterGroup('AdvocacyAlertRelatedState', ' State', 'All States', '', false, true, 'checkbox'),
	Categories: new FormControl.FilterGroup('Categories', 'Topic', 'All Topics', '', false, true, 'checkbox'),
	//disease_category: new FormControl.FilterGroup('disease_category', 'Filter by Disease', 'All Diseases', '', false, true, 'checkbox'),
	//issue_topic: new FormControl.FilterGroup('issue_topic', 'Filter by Topic', 'All Topics', '', false, true, 'checkbox'),
	//AlertType: new FormControl.FilterGroup('AlertType', 'Filter by Type', 'All Types', '', false, true, 'select'),
	searchTerm: new FormControl.FilterGroup(
		'SearchTerm', 'Search', null, null, false, true, 'textbox',
		new FormControl.Textbox('Search')
	),
};

FormControl.assignFilters(filterObj, filters);

export { filters as default };